<template>
    <div>
        <v-tabs
            v-model="tab"
            centered
            background-color="blue-grey"
            dark
            slider-color="yellow"
        > 
            <v-tab
                @click="$emit('tipoOficioSeleccionado', 'entrante');" 
            >Entrantes</v-tab>
            <v-tab 
                @click="$emit('tipoOficioSeleccionado', 'generado');" 
            >Generados</v-tab>

        </v-tabs>
        
    </div>
</template>

<script>
export default {
    data: () => ({
        tab: null,
    }),
}

</script>